module.exports = __webpack_public_path__ + "img/7b94b34.png";